// Saved canonical rows contain these aliases as well as the calculation snapshot.
// Refresh aliases from the existing calculator after edits; never reprice history.
export function buildCurtainRowFinancialAliasesForSave(calculation) {
  if (calculation.usesCalculationSnapshot) return {};
  const stitching = Number(calculation.stitchingCost || 0);
  const track = Number(calculation.trackCost || 0);
  const bend = Number(calculation.bendAmount || 0);
  return {
    fabricAmount: Number(calculation.fabricCost || 0),
    stitchingAmount: stitching,
    trackAmount: track,
    productCharge: Number(calculation.productCharge ?? calculation.sqftAmount ?? 0),
    rowSubtotal: Number(calculation.rowTotal || 0),
    stitchingTrackAmount: Math.round((stitching + track + bend) * 100) / 100,
  };
}
